import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SidebarContainer = styled('div')({
  '& .MuiDrawer-paper': {
    position: 'relative',
    overflow: 'visible',
    padding: '0',
  },
  '& .MuiDrawer-root': {
    padding: '0',
    height: '100%',
    overflow: 'visible',
  },
  '.MuiBox-root': {
    height: '100%',
    overflow: 'visible',
  },
});

export const SidebarDoubleArrowToggleButton = styled(IconButton)({
  backgroundColor: '#1A1A2E',
  width: 24,
  height: 24,
  zIndex: 1100,
  borderRadius: 4,
  border: '1px solid white',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'fixed',
  right: -10,
  top: 90,
  '&:hover': {
    backgroundColor: '#FF5403',
  },
});

export const SidebarLogo = styled('div')({
  display: 'flex',
  justifyContent: 'center',
});
